var PropertyType;
(function (PropertyType) {
    PropertyType[PropertyType["hospitality"] = 1] = "hospitality";
    PropertyType[PropertyType["industrial"] = 2] = "industrial";
    PropertyType[PropertyType["land"] = 3] = "land";
    PropertyType[PropertyType["office"] = 5] = "office";
    PropertyType[PropertyType["generalRetail"] = 6] = "generalRetail";
    PropertyType[PropertyType["flex"] = 7] = "flex";
    PropertyType[PropertyType["sportsAndEntertainment"] = 8] = "sportsAndEntertainment";
    PropertyType[PropertyType["mixedUse"] = 9] = "mixedUse";
    PropertyType[PropertyType["specialty"] = 10] = "specialty";
    PropertyType[PropertyType["multifamily"] = 11] = "multifamily";
    PropertyType[PropertyType["healthCare"] = 13] = "healthCare";
    PropertyType[PropertyType["student"] = 31] = "student";
})(PropertyType || (PropertyType = {}));
;
export default PropertyType;
//# sourceMappingURL=property-type.js.map